import {Theme} from '@lookiero/aurora';
import StyleSheet from 'react-native-extended-stylesheet';

const {colorBgBase, space2, space4, space6, space8, borderRadius4} = Theme.get();

const style = StyleSheet.create({
  wrapper: {
    paddingHorizontal: space8,
    backgroundColor: colorBgBase,
    paddingVertical: space6,
  },
  rounded: {
    borderRadius: borderRadius4,
  },
  progressBar: {
    marginVertical: space4,
  },
  information: {
    marginBottom: space4,
  },
  infoBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  infoIcon: {
    marginRight: space2,
  },
});

export default style;
